(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTitleBarAddButton', drvTitleBarAddButton);

    drvTitleBarAddButton.$inject = [];

    /**
     * @ngdoc directive
     * @name drvTitleBarAddButton
     * 
     * @description
     * Creates a title bar button specifically used for adding an item.
     * To be used with drvTitleBar.
     *
     * # Scope Properties
     * {string} itemName - Text to be shown for the caption after 'Add' E.g. 'Add <text>'. Optional.
     * {function} onClick - Function to be invoked when the button is clicked. Optional.
     * {bool} disabled - Disables the button. Optional.
     */
    function drvTitleBarAddButton() {
        var directive = {
            restrict: 'E',
            scope: {
                itemName: '<?',
                onClick: '&?',
                disabled: '<?'
            },
            template:
                '<drv-title-bar-button class="add-button" icon="\'plus\'" text="\'Add\'" caption="\'Add\' + (itemName ? \' \' + itemName : \'\')" on-click="onClick()" disabled="disabled"></drv-title-bar-button>'
        };
        return directive;
    }
})();